import { Pipe, PipeTransform, inject } from '@angular/core';
import { remove } from 'remove-accents'; 'remove-accents'
import { ArticuloDTO, CodigoBarrasArticuloDTO } from 'src/app/Models/ApiV2/ArticuloDTO';
import { CategoriaDTO } from 'src/app/Models/ApiV2/CategoriaDTO';
import { FamiliaArticuloDTO } from 'src/app/Models/ApiV2/FamiliaArticuloDTO';
import { MarcaDTO } from 'src/app/Models/ApiV2/MarcaDTO';
import { VariablesGlobalesService } from 'src/app/services/variables-globales.service';
const lodash = require('lodash');

@Pipe({
  name: 'buscarArticulo',
  standalone: true
})
export class BuscarArticuloPipe implements PipeTransform {
  variablesGlobales = inject(VariablesGlobalesService);

  private  arrayFiltrado:  ArticuloDTO[] = [];
  private values : string[] = [];
  private acumulaFiltros:  ArticuloDTO[] = []
  private acumuladoFinal:  ArticuloDTO[] = []

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }




  transform(array: ArticuloDTO[],
    texto: string = '',
    fullArray: ArticuloDTO[],
  ): ArticuloDTO[] {
    //console.log('categoriasArticulosSeleccionadas: ',categoriasArticulosSeleccionadas);
    //console.log('familiasArticulosSeleccionadas: ',familiasArticulosSeleccionadas);
    //console.log('marcasArticulosSeleccionadas: ', marcasArticulosSeleccionadas);

    // if (texto === '') {
    //   return array;
    // }

    if (!array) {
      return array;
    }

    if (texto?.length == 0) {
      return array;
    }

    texto = remove(texto?.toLowerCase());

    //this.arrayFiltrado = fullArray;

    // let arrayFiltradoCategorias:ArticuloDTO [] = []
    // if(categoriasArticulosSeleccionadas.length!=0){
    //   lodash.filter(fullArray, function(articulo:ArticuloDTO){
    //     if(articulo?.categorias && articulo?.categorias.length != 0){
    //       articulo?.categorias.filter(catArticulo => {
    //         if(lodash.some(categoriasArticulosSeleccionadas,{'id':catArticulo?.id})){
    //           if(!arrayFiltradoCategorias.includes(articulo)){
    //             arrayFiltradoCategorias.push(articulo)
    //             return
    //           }
              
    //         }
    //       })
    //     }else{
    //       return
    //     }
    //   })
    // }else{
    //   arrayFiltradoCategorias = fullArray
    // }
    // //console.log('arrayFiltradoCategorias: ',arrayFiltradoCategorias);
    
    
    // let arrayFiltradoFamilias:ArticuloDTO [] = []
    // if(familiasArticulosSeleccionadas.length!=0){
    //   lodash.filter(arrayFiltradoCategorias, function(articulo:ArticuloDTO){
    //     if(lodash.some(familiasArticulosSeleccionadas, {'id':articulo?.familia?.id})){
    //       if(!arrayFiltradoFamilias.includes(articulo)){
    //         arrayFiltradoFamilias.push(articulo)
    //         return
    //       }
        
    //     }

    //   })
    // }else{
    //   arrayFiltradoFamilias = arrayFiltradoCategorias
    // }
    // //console.log('arrayFiltradoFamilias: ',arrayFiltradoFamilias);


    // let arrayFiltradoMarcas:ArticuloDTO [] = []
    // if(marcasArticulosSeleccionadas.length!=0){
    //   lodash.filter(arrayFiltradoFamilias, function(articulo:ArticuloDTO){
    //     if(lodash.some(marcasArticulosSeleccionadas, {'id':articulo?.marca?.id})){
    //       if(!arrayFiltradoMarcas.includes(articulo)){
    //         arrayFiltradoMarcas.push(articulo)
    //         return
    //       }
          
    //     }

    //   })
    // }else{
    //   arrayFiltradoMarcas = arrayFiltradoFamilias
    // }

    // console.log('arrayFiltradoMarcas: ',arrayFiltradoMarcas);
    
    this.arrayFiltrado = fullArray
    this.values = texto.split(' ');
    
    this.values.forEach((value, index) => {

    this.acumulaFiltros = this.arrayFiltrado.filter((articulo : ArticuloDTO) => {
      return(
      //  remove(this.evaluar(articulo?.bultos?.toString().toLowerCase())).includes(texto) ||
        remove(this.evaluar(articulo?.codigo?.toLowerCase())).includes(value) ||
        remove(this.evaluar(articulo?.id?.toString().toLowerCase())).includes(value) ||
        remove(this.evaluar(articulo?.nombre?.toLowerCase())).includes(value) ||
      //  remove(this.evaluar(articulo?.descripcionAmpliada?.toLowerCase())).includes(value) ||
      // remove(this.evaluar(articulo?.observaciones?.toLowerCase())).includes(value) ||
        remove(this.evaluar(articulo?.tipo?.toString().toLowerCase())).includes(value) ||
      //  remove(this.evaluar(articulo?.peso?.toString().toLowerCase())).includes(value) ||
        remove(this.evaluar(articulo?.marca?.nombre?.toLowerCase())).includes(value) ||
      //  remove(this.evaluar(articulo?.modelo?.nombre?.toString().toLowerCase())).includes(texto) ||
      //  (articulo?.categorias?.filter(categoria => categoria.nombre.toLowerCase().includes(value)))
        //(articulo?.codigosBarras?.filter(codigoBarras => codigoBarras.codigoBarras.includes(value)))

         this.codigosBarras(articulo?.codigosBarras, value)
        );
      });
      if(index == 0) this.acumuladoFinal = this.acumulaFiltros
      else this.acumuladoFinal = lodash.intersectionBy(this.acumuladoFinal, this.acumulaFiltros, 'id')
      })
      this.variablesGlobales.elementosPipeArticulos = this.acumuladoFinal.length;
      return this.acumuladoFinal
    
    }
  
  

  evaluar(valor: string) : string {
    if (!valor) valor = "";
    return valor
  }

  codigosBarras(codigo: CodigoBarrasArticuloDTO[], value: string): boolean {
    let encontrado: boolean = false;
    let contiene : boolean = false;
    codigo?.forEach(barras => {
      contiene = remove(this.evaluar(barras.codigoBarras.toLowerCase())).includes(value)
      console.log(" etiqueta " , barras , ' contiene ' , contiene)
      if (contiene) encontrado = true;
    })

    console.log(" etiqueta encontrado ", encontrado)
    return encontrado
  }

}
